import { all } from 'redux-saga/effects';
import { loginSagas } from '../containers/Login';
import { structureSagas } from '../containers/StructureContent';
import filtersSagas from '../containers/Filters/sagas/sagas';
import addressableOpportunitySagas from '../containers/AddressableOpportunity/sagas';

export default function* rootSaga() {
    yield all([...loginSagas, ...structureSagas, ...filtersSagas, ...addressableOpportunitySagas]);
}
